module.exports = __webpack_public_path__ + "static/03_LP-Tulsa-Procedure-Prostate-Website-8117ad3f6c7a13840d6f105a8ae4c28a.jpg";